export const SET_ENGINE_QUERY_STRING = 'SET_ENGINE_QUERY_STRING';
export const REPLACE_ENGINE_QUERY_STRINGS = 'REPLACE_ENGINE_QUERY_STRINGS';
export const TOGGLE_MAIN_SEARCH_RESULTS_VEIL = 'TOGGLE_MAIN_SEARCH_RESULTS_VEIL';
export const TOGGLE_MAIN_SEARCH_LOADING_AFTER_ACTION = 'TOGGLE_MAIN_SEARCH_LOADING_AFTER_ACTION';
export const SET_TRIGGER_FOR_REFRESHING_MAIN_SEARCH_RESULTS = 'SET_TRIGGER_FOR_REFRESHING_MAIN_SEARCH_RESULTS';
export const RESET_TRIGGER_FOR_REFRESHING_MAIN_SEARCH_RESULTS = 'RESET_TRIGGER_FOR_REFRESHING_MAIN_SEARCH_RESULTS';
